(function(){
  var root=document.getElementById('fh-dv');
  if(!root)return;
  var qs=new URLSearchParams(location.search);
  var posted=qs.get('contact_posted')==='true';
  var ref=qs.get('ref')||'';
  var want=qs.get('devis')==='1';
  var SK='fh_dv_lines_v2';
  var hasErr=!!root.querySelector('.fh-dv__err');
  try{
    var sent=sessionStorage.getItem('fh_dv_sent')==='1';
    if(posted){
      sessionStorage.removeItem('fh_dv_sent');
      if(sent){want=true;sessionStorage.removeItem(SK);}else{want=false;}
    }else if(sent&&hasErr){
      sessionStorage.removeItem('fh_dv_sent');want=true;
    }
  }catch(e){}
  if(!want)return;
  root.hidden=false;
  document.documentElement.classList.add('fh-dv-mode');
  var $=function(id){return document.getElementById(id);};
  var fm=$('fh-dv-form');
  var listEl=$('fh-dv-lines');
  if(!fm||!listEl)return;
  fm.noValidate=true;
  var NL=String.fromCharCode(10);
  var lines=[];
  try{lines=JSON.parse(sessionStorage.getItem(SK)||'[]')||[];}catch(e){lines=[];}
  var save=function(){try{sessionStorage.setItem(SK,JSON.stringify(lines));}catch(e){}};
  var cur=(window.Shopify&&Shopify.currency&&Shopify.currency.active)||'EUR';
  var money=function(c){var n=(Number(c)||0)/100;try{return new Intl.NumberFormat('fr-FR',{style:'currency',currency:cur}).format(n);}catch(e){return n.toFixed(2)+' €';}};
  var UNITS=['unités','kg','L','cartons','palettes'];
  var TEMPS=['Ambiant (épicerie sèche)','Frais','Surgelé','Je ne sais pas'];
  var el=function(tag,cls,txt){var e=document.createElement(tag);if(cls)e.className=cls;if(txt!==undefined&&txt!==null)e.textContent=txt;return e;};
  var sel=function(opts,val){var s=el('select');opts.forEach(function(o){var op=el('option',null,typeof o==='object'?o.l:o);op.value=typeof o==='object'?o.v:o;if(op.value===String(val))op.selected=true;s.appendChild(op);});return s;};
  var field=function(label,ctrl,full){var w=el(ctrl.tagName==='DIV'?'div':'label','fh-dv__row'+(full?' fh-dv__row--full':''));w.appendChild(el('span','fh-dv__lab',label));w.appendChild(ctrl);return w;};
  var curVar=function(L){if(!L.variants||!L.variants.length)return null;for(var k=0;k<L.variants.length;k++){if(String(L.variants[k].id)===String(L.vid))return L.variants[k];}return L.variants[0];};
  var withW=function(u,w){if(!u)return '';if(u.indexOf('//')===0)u='https:'+u;return u+(u.indexOf('?')>-1?'&':'?')+'width='+w;};

  function render(){
    listEl.innerHTML='';
    lines.forEach(function(L,i){
      var box=el('div','fh-dv__line'+(L.t==='free'?' fh-dv__line--free':''));
      var top=el('div','fh-dv__lt');
      if(L.t==='cat'){
        var th=el('div','fh-dv__thumb');
        if(L.img){var im=el('img');im.src=L.img;im.alt='';im.loading='lazy';th.appendChild(im);}
        top.appendChild(th);
        var meta=el('div','fh-dv__meta');
        var a=el('a','fh-dv__name',L.title);a.href=L.url;a.target='_blank';a.rel='noopener';meta.appendChild(a);
        var v=curVar(L);
        meta.appendChild(el('p','fh-dv__ref',[L.vendor,v&&v.sku?'Réf. '+v.sku:'',v?'Prix catalogue '+money(v.price):''].filter(Boolean).join(' · ')));
        top.appendChild(meta);
      }else{
        top.appendChild(el('span','fh-dv__badge','Hors catalogue'));
        top.appendChild(el('span','fh-dv__fill'));
      }
      var rm=el('button','fh-dv__rm','×');rm.type='button';rm.setAttribute('aria-label','Retirer cette ligne');
      rm.addEventListener('click',function(){lines.splice(i,1);save();render();});
      top.appendChild(rm);
      box.appendChild(top);
      var g=el('div','fh-dv__lg');
      if(L.t==='free'){
        var nm=el('input');nm.type='text';nm.value=L.name||'';nm.placeholder='ex. wasabi liquide, vinaigre de vin rouge 6 %, huile de coco désodorisée…';
        nm.addEventListener('input',function(){L.name=nm.value;save();});
        g.appendChild(field('Produit recherché *',nm,true));
        var ds=el('textarea');ds.rows=3;ds.value=L.desc||'';ds.placeholder='Spécifications, marque ou origine souhaitée, qualité, calibre, usage…';
        ds.addEventListener('input',function(){L.desc=ds.value;save();});
        g.appendChild(field('Description',ds,true));
        var tp=sel(TEMPS,L.temp||TEMPS[0]);tp.addEventListener('change',function(){L.temp=tp.value;save();});
        g.appendChild(field('Température',tp));
      }else if(L.variants&&L.variants.length>1){
        var vs=sel(L.variants.map(function(x){return {v:String(x.id),l:(x.title||'Format')+' — '+money(x.price)};}),L.vid);
        vs.addEventListener('change',function(){L.vid=vs.value;save();render();});
        g.appendChild(field('Format',vs));
      }
      var q=el('div','fh-dv__qty');
      var qi=el('input');qi.type='number';qi.min='0';qi.step='any';qi.setAttribute('inputmode','decimal');qi.value=L.qty||'';qi.placeholder='Quantité';
      qi.addEventListener('input',function(){L.qty=qi.value;save();});
      var us=sel(UNITS,L.unit||'unités');us.addEventListener('change',function(){L.unit=us.value;save();});
      q.appendChild(qi);q.appendChild(us);
      g.appendChild(field('Quantité *',q));
      var nt=el('input');nt.type='text';nt.value=L.note||'';nt.placeholder='Conditionnement, alternative acceptée…';
      nt.addEventListener('input',function(){L.note=nt.value;save();});
      var fullNote=L.t==='free'||!!(L.variants&&L.variants.length>1);
      g.appendChild(field('Commentaire',nt,fullNote));
      box.appendChild(g);
      listEl.appendChild(box);
    });
    $('fh-dv-empty').hidden=lines.length>0;
    $('fh-dv-count').textContent=lines.length?lines.length+' ligne'+(lines.length>1?'s':'')+' dans votre demande':'';
  }

  function flash(i,sel2){
    var b=listEl.children[i];if(!b)return;
    var f=b.querySelector(sel2||'.fh-dv__qty input');if(f){try{f.focus({preventScroll:true});}catch(e){f.focus();}}
    b.scrollIntoView({behavior:'smooth',block:'center'});
    b.classList.add('is-flash');setTimeout(function(){b.classList.remove('is-flash');},1000);
  }

  function addProduct(handle){
    for(var k=0;k<lines.length;k++){if(lines[k].t==='cat'&&lines[k].handle===handle){flash(k);return Promise.resolve();}}
    return fetch('/products/'+encodeURIComponent(handle)+'.js',{credentials:'same-origin'})
      .then(function(r){return r.ok?r.json():null;})
      .then(function(p){
        if(!p)return;
        var vars=(p.variants||[]).map(function(v){var t=v.public_title||v.title||'';if(/^default title$/i.test(t))t='';return {id:String(v.id),title:t,price:v.price,sku:v.sku||''};});
        if(vars.length===1)vars[0].title='';
        lines.push({t:'cat',handle:p.handle,title:p.title,vendor:p.vendor||'',img:withW(p.featured_image,160),url:location.origin+'/products/'+p.handle,variants:vars,vid:vars[0]?vars[0].id:'',qty:'',unit:'unités',note:''});
        save();render();flash(lines.length-1);
      }).catch(function(){});
  }

  function addFree(name){
    lines.push({t:'free',name:name||'',desc:'',temp:TEMPS[0],qty:'',unit:'kg',note:''});
    save();render();flash(lines.length-1,name?'textarea':'input');
  }

  var qIn=$('fh-dv-q'),res=$('fh-dv-res'),tmr=null,lastQ='';
  var closeRes=function(){res.hidden=true;};
  function search(v){
    lastQ=v;
    var u='/search/suggest.json?q='+encodeURIComponent(v)+'&resources[type]=product&resources[limit]=8&resources[options][unavailable_products]=last';
    fetch(u,{credentials:'same-origin'}).then(function(r){return r.json();}).then(function(d){
      if(v!==lastQ)return;
      var ps=(d&&d.resources&&d.resources.results&&d.resources.results.products)||[];
      res.innerHTML='';
      ps.forEach(function(p){
        var b=el('button','fh-dv__ri');b.type='button';
        var th=el('span','fh-dv__rth');
        var src=p.featured_image&&p.featured_image.url?p.featured_image.url:p.image;
        if(src){var im=el('img');im.src=withW(src,96);im.alt='';th.appendChild(im);}
        b.appendChild(th);
        var tx=el('span','fh-dv__rtx');
        tx.appendChild(el('span','fh-dv__rn',p.title));
        var pr=parseFloat(p.price);
        tx.appendChild(el('span','fh-dv__rm2',[p.vendor,isNaN(pr)?'':money(Math.round(pr*100))].filter(Boolean).join(' · ')));
        b.appendChild(tx);
        b.appendChild(el('span','fh-dv__rplus','+ Ajouter'));
        b.addEventListener('click',function(){addProduct(p.handle);qIn.value='';res.innerHTML='';closeRes();});
        res.appendChild(b);
      });
      var fb=el('button','fh-dv__ri fh-dv__ri--free');fb.type='button';
      fb.appendChild(el('span','fh-dv__rtx',ps.length?'Pas le bon produit ? Ajouter « '+v+' » comme produit hors catalogue':'Rien trouvé pour « '+v+' » : l’ajouter comme produit hors catalogue, nous le sourçons'));
      fb.addEventListener('click',function(){addFree(v);qIn.value='';res.innerHTML='';closeRes();});
      res.appendChild(fb);
      res.hidden=false;
    }).catch(function(){});
  }
  qIn.addEventListener('input',function(){clearTimeout(tmr);var v=qIn.value.trim();if(v.length<2){res.innerHTML='';closeRes();return;}tmr=setTimeout(function(){search(v);},220);});
  qIn.addEventListener('focus',function(){if(res.children.length)res.hidden=false;});
  qIn.addEventListener('keydown',function(e){
    if(e.key==='Enter'){e.preventDefault();var f=res.querySelector('.fh-dv__ri');if(f&&!res.hidden)f.click();}
    if(e.key==='Escape')closeRes();
    if(e.key==='ArrowDown'){var f2=res.querySelector('.fh-dv__ri');if(f2&&!res.hidden){e.preventDefault();f2.focus();}}
  });
  res.addEventListener('keydown',function(e){
    var a=document.activeElement;if(!a||!a.classList.contains('fh-dv__ri'))return;
    if(e.key==='ArrowDown'&&a.nextElementSibling){e.preventDefault();a.nextElementSibling.focus();}
    if(e.key==='ArrowUp'){e.preventDefault();if(a.previousElementSibling)a.previousElementSibling.focus();else qIn.focus();}
    if(e.key==='Escape'){closeRes();qIn.focus();}
  });
  document.addEventListener('click',function(e){if(!res.contains(e.target)&&e.target!==qIn)closeRes();});
  $('fh-dv-free').addEventListener('click',function(){addFree('');});

  var pays=$('fh-dv-pays'),tvaRow=$('fh-dv-tva-row');
  var syncPays=function(){tvaRow.hidden=pays.value==='France';};
  pays.addEventListener('change',syncPays);syncPays();

  var groupVal=function(id){var g=fm.querySelector('[data-grp='+id+']');if(!g)return '';var out=[];g.querySelectorAll('input:checked').forEach(function(x){out.push(x.value);});return out.join(', ');};
  var val=function(id){var x=$(id);return x?String(x.value||'').trim():'';};
  var radio=function(name){var x=fm.querySelector('input[name="'+name+'"]:checked');return x?x.value:'';};
  var frDate=function(s){var m=String(s||'').split('-');return m.length===3?m[2]+'/'+m[1]+'/'+m[0]:s;};

  function buildBody(){
    var o=[];
    var push=function(label,v){if(v)o.push(label+' : '+v);};
    o.push('DEMANDE DE DEVIS — '+lines.length+' ligne'+(lines.length>1?'s':''));
    o.push('');
    o.push('PRODUITS');
    lines.forEach(function(L,i){
      if(L.t==='cat'){
        var v=curVar(L);
        o.push((i+1)+'. '+L.title+(v&&v.title?' — '+v.title:''));
        o.push('   Quantité : '+L.qty+' '+L.unit);
        var m=[];if(L.vendor)m.push(L.vendor);if(v&&v.sku)m.push('Réf. '+v.sku);if(v)m.push('prix catalogue '+money(v.price));
        if(m.length)o.push('   '+m.join(' · '));
        o.push('   '+L.url);
      }else{
        o.push((i+1)+'. [HORS CATALOGUE] '+String(L.name||'').trim());
        o.push('   Quantité : '+L.qty+' '+L.unit);
        o.push('   Température : '+L.temp);
        if(L.desc)o.push('   Description : '+String(L.desc).split(NL).join(' / '));
      }
      if(L.note)o.push('   Commentaire : '+L.note);
    });
    o.push('');o.push('BESOIN');
    push('Usage / application',val('fh-dv-usage'));
    push('Fréquence',val('fh-dv-freq'));
    push('Livraison souhaitée le',frDate(val('fh-dv-date')));
    push('Paliers à chiffrer',val('fh-dv-paliers'));
    push('Conditionnement',val('fh-dv-cond'));
    push('Prix demandé',radio('contact[Prix demandé]'));
    push('Exigences qualité',groupVal('fh-dv-f-exig'));
    push('Documents à joindre',groupVal('fh-dv-f-docs'));
    push('Prix cible / actuel',val('fh-dv-cible'));
    o.push('');o.push('LIVRAISON');
    push('Pays',val('fh-dv-pays'));
    push('Code postal et ville',val('fh-dv-ville'));
    push('Accès',val('fh-dv-acces'));
    push('Créneaux / contraintes',val('fh-dv-crn'));
    o.push('');o.push('CLIENT');
    push('Type',val('fh-dv-type'));
    push('Société',val('fh-dv-soc'));
    push('SIREN / SIRET',val('fh-dv-siret'));
    if(pays.value!=='France')push('TVA intracommunautaire',val('fh-dv-tva'));
    push('Contact',val('fh-dv-nom'));
    push('E-mail',val('fh-dv-mail'));
    push('Téléphone',val('fh-dv-tel'));
    var msg=val('fh-dv-msg');if(msg){o.push('');o.push('MESSAGE');o.push(msg);}
    return o.join(NL);
  }

  fm.addEventListener('submit',function(e){
    var errs=[];
    if(!lines.length)errs.push('Ajoutez au moins un produit, du catalogue ou hors catalogue.');
    lines.forEach(function(L,i){
      var n=parseFloat(String(L.qty||'').replace(',','.'));
      if(L.t==='free'&&!String(L.name||'').trim())errs.push('Ligne '+(i+1)+' : indiquez le produit recherché.');
      if(!(n>0))errs.push('Ligne '+(i+1)+' : indiquez une quantité.');
    });
    fm.querySelectorAll('[data-req]').forEach(function(x){if(!String(x.value||'').trim())errs.push(x.getAttribute('data-req')+' : champ obligatoire.');});
    var em=val('fh-dv-mail');
    if(em){var at=em.indexOf('@');if(at<1||em.indexOf('.',at)<at+2)errs.push('Adresse e-mail invalide.');}
    var box=$('fh-dv-errs');
    if(errs.length){
      e.preventDefault();
      box.innerHTML='';errs.forEach(function(t){box.appendChild(el('p',null,t));});
      box.hidden=false;box.scrollIntoView({behavior:'smooth',block:'center'});
      return;
    }
    box.hidden=true;
    $('fh-dv-f-exig').value=groupVal('fh-dv-f-exig');
    $('fh-dv-f-docs').value=groupVal('fh-dv-f-docs');
    $('fh-dv-f-n').value=String(lines.length);
    $('fh-dv-f-prods').value=lines.map(function(L){return (L.t==='cat'?L.title:'[Hors catalogue] '+L.name)+' × '+L.qty+' '+L.unit;}).join(' | ');
    $('fh-dv-f-body').value=buildBody();
    try{sessionStorage.setItem('fh_dv_sent','1');}catch(x){}
  });

  render();
  if(ref&&!posted){addProduct(ref);}
})();